
import React, { useState } from 'react';
import './SignatureDialog.css';
import SignatureCanvas from 'react-signature-canvas';

const SignatureDialog = ({ signatureRef, setSignatureRef }) => {

  const handleSave = () => {
    const signatureData = signatureRef.toDataURL();
    //handleSignatureSubmit(signatureData);
    setSignatureRef(null);
  };

  return (
    <div className="signature-dialog">
      {/* <label>Draw your signature:</label> */}
      <SignatureCanvas
        ref={(ref) => setSignatureRef(ref)}
        penColor="black"
        canvasProps={{ width: 400, height: 200, className: 'signature-canvas' }}
      />


    </div>
  );
};

export default SignatureDialog;
